export enum IncubatingFeaturesKey {}

export type IncubatingFeatures = { [key in IncubatingFeaturesKey]?: boolean };

export const hasIncubatingFeature = (
  incubatingFeatures: IncubatingFeatures | null | undefined,
  key: IncubatingFeaturesKey,
) => {
  return incubatingFeatures && key in incubatingFeatures && incubatingFeatures[key];
};
